import React from 'react';
import classnames from 'classnames';
import { SignalVariant } from '../types';
import { Text } from '../text';
import { Icon, IconProps } from '../icon';
import { IconButton } from '../icon-button';
import styles from './notification.module.scss';

export type NotificationProps = {
  label?: string;
  text: string;
  variant?: SignalVariant;
  closeButton?: { ariaLabel: string; onClick: () => void };
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'className'>;

const baseClass = 'notification';

const getIcon = (variant: SignalVariant): IconProps['name'] => {
  switch (variant) {
    case 'error':
      return 'error--medium';
    case 'informational':
      return 'info-legal--medium';
    case 'warning':
      return 'warning--medium';
    case 'success':
      return 'successful-checkmark--medium';
  }
};

export const Notification: React.FC<NotificationProps> = ({
  label,
  text,
  variant = 'informational',
  className,
  closeButton
}) => {
  const classes = classnames(styles[baseClass], styles[`${baseClass}--${variant}`], className);

  return (
    <div className={classes} data-testid="notification-component">
      <div className={styles[`${baseClass}__content-container`]}>
        <Icon name={getIcon(variant)} className={styles[`${baseClass}__icon`]} />
        <div className={styles[`${baseClass}__content`]}>
          {label && <span className={styles[`${baseClass}__label`]}>{label}</span>}
          <Text variant="paragraph-100" className={styles[`${baseClass}__text`]}>
            {text}
          </Text>
        </div>
      </div>
      {closeButton && (
        <IconButton
          variant="ghost"
          ariaLabel={closeButton.ariaLabel}
          onClick={closeButton.onClick}
          iconName="close-without-circle--small"
          className={styles[`${baseClass}__button`]}
          size="200"
        />
      )}
    </div>
  );
};
